module.exports = __webpack_public_path__ + "456bc3fd461580dfab426a7936da22c6.svg";